<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="desserts"
      height="70vh"
      :items-per-page="500"
      :footer-props="{
        itemsPerPageOptions: [500, 1000, 2000, 3000, 4000],
      }"
      :search="search"
      :custom-filter="filtroBusca"
      :fixed-header="true"
      :options.sync="options"
      class="elevation-3"
    >
      <!-- Slot para a coluna ID -->
      <template v-slot:item.idpessoa="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.idpessoa }}
        </span>
      </template>

      <!-- Slot para a coluna Nome Completo -->
      <template v-slot:item.nome_completo="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.nome_completo }}
        </span>
      </template>

      <!-- Slot para a coluna Telefone -->
      <template v-slot:item.telefone="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.telefone }}
        </span>
      </template>

      <!-- Slot para a coluna Email -->
      <template v-slot:item.email="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.email }}
        </span>
      </template>

      <!-- Slot para a coluna Assessor -->
      <template v-slot:item.assessor.name="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{ item.assessor.name }}
        </span>
      </template>

      <!-- Slot para a coluna Equipes (compartilhamento entre equipes) -->
      <template v-slot:item.equipes="{ item }">
        <v-chip
          v-for="c in equipesOrdenadas(item)"
          :key="c.id"
          x-small
          class="ma-1"
          :color="c.id === candidatoAtivoId ? 'green' : 'amber darken-2'"
          text-color="white"
        >
          {{ c.name }}
        </v-chip>
      </template>

      <!-- Slot para a coluna Observações (truncada + tooltip) -->
      <template v-slot:item.observacoes="{ item }">
        <v-tooltip bottom :disabled="!item.observacoes">
          <template v-slot:activator="{ on }">
            <span v-on="on" :class="{ 'red--text': item.cad_dup === 1 }">
              {{ truncar(item.observacoes, 60) }}
            </span>
          </template>
          <span>{{ item.observacoes }}</span>
        </v-tooltip>
      </template>

      <!-- Slot para a coluna Cad.Duplicado -->
      <template v-slot:item.cad_dup="{ item }">
        <span :class="{ 'red--text': item.cad_dup === 1 }">
          {{
            item.cad_dup === 1
              ? "REGISTRO DUPLICADO REMOVER"
              : "REGISTRO VALIDADO"
          }}
        </span>
      </template>

      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title
            >Cadastro de Pessoas - {{ metas.total_cad }} /
            {{ metas.total }}</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            class="mr-10"
            v-model="search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          ></v-text-field>

          <v-icon
            v-if="metas.total_cad > 0"
            title="Imprimir Lista de Cadastro"
            class="mr-5"
            @click="getReportAssessor"
            >mdi-printer</v-icon
          >
          <v-btn
            v-if="metas.show"
            small
            rounded
            color="primary"
            dark
            class="mb-2"
            @click="novaPessoa"
            >Novo</v-btn
          >

          <v-dialog persistent v-model="dialog" max-width="600px">
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.nome_completo"
                        counter
                        label="Nome Completo*"
                        :error-messages="nameErrors"
                        @input="$v.editedItem.nome_completo.$touch()"
                        @blur="$v.editedItem.nome_completo.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.titulo_eleitoral"
                        label="Código principal*"
                        prepend-inner-icon="mdi-ballot-outline"
                        v-mask="'#### #### ####'"
                        :error-messages="tituloEleitoralErrors"
                        @input="$v.editedItem.titulo_eleitoral.$touch()"
                        @blur="$v.editedItem.titulo_eleitoral.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.cpf"
                        label="CPF"
                        prepend-inner-icon="mdi-card-account-details"
                        v-mask="'###.###.###-##'"
                        :error-messages="cpfErrors"
                        @input="$v.editedItem.cpf.$touch()"
                        @blur="$v.editedItem.cpf.$touch()"
                        style="margin-right: 5px"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.telefone"
                        label="Telefone*"
                        prepend-inner-icon="mdi-phone"
                        :error-messages="telefoneErrors"
                        v-mask="'(##) #####-####'"
                        @input="$v.editedItem.telefone.$touch()"
                        @blur="$v.editedItem.telefone.$touch()"
                        style="margin-left: 5px"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-select
                        v-model="editedItem.zona"
                        :items="selects.zonas.items"
                        item-text="zona"
                        item-value="zona"
                        chips
                        label="Selecione Zona*"
                        height="10"
                        outlined
                        style="margin-right: 5px"
                        :error-messages="zonaErrors"
                        @input="$v.editedItem.zona.$touch()"
                        @blur="$v.editedItem.zona.$touch()"
                      ></v-select>
                    </v-col>

                    <v-col class="pa-0" cols="6" xs="6">
                      <v-text-field
                        outlined
                        v-model="editedItem.secao"
                        label="Seção*"
                        style="margin-left: 5px"
                        :error-messages="secaoErrors"
                        v-mask="'####'"
                        @input="$v.editedItem.secao.$touch()"
                        @blur="$v.editedItem.secao.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-text-field
                        outlined
                        v-model="editedItem.email"
                        label="Email"
                        prepend-inner-icon="mdi-email"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email.$touch()"
                        @blur="$v.editedItem.email.$touch()"
                      ></v-text-field>
                    </v-col>

                    <v-col class="pa-0" cols="12" xs="12">
                      <v-textarea
                        outlined
                        auto-grow
                        rows="3"
                        v-model="editedItem.observacoes"
                        prepend-inner-icon="mdi-note-text-outline"
                        label="Observações"
                      ></v-textarea>
                    </v-col>
                    <v-col
                      class="pa-0"
                      cols="12"
                      xs="12"
                      v-if="listaCandidatos.length > 1"
                    >
                      <fieldset
                        class="equipes-group rounded pa-2 mb-2"
                        :class="{ 'equipes-group--error': $v.editedItem.candidatos.$error }"
                        role="group"
                        aria-labelledby="equipes-legend"
                      >
                        <legend
                          id="equipes-legend"
                          class="text-caption font-weight-medium px-1 d-flex align-center"
                        >
                          <v-icon small class="mr-1">mdi-account-multiple-check</v-icon>
                          Vale para as equipes *
                        </legend>

                        <div
                          v-for="eq in candidatosParaSelecao"
                          :key="eq.idcandidato"
                          class="d-flex align-center"
                        >
                          <v-checkbox
                            v-model="editedItem.candidatos"
                            :value="eq.idcandidato"
                            :disabled="eq.disabled"
                            dense
                            hide-details
                            class="ma-0 pa-0 flex-grow-1"
                            @change="$v.editedItem.candidatos.$touch()"
                          >
                            <template #label>
                              <div
                                class="d-flex flex-wrap align-center"
                                style="gap: 8px; width: 100%"
                              >
                                <span :class="{ 'text--disabled': eq.disabled }">{{
                                  eq.nome
                                }}</span>
                                <v-chip
                                  v-if="eq.metaAtingida"
                                  x-small
                                  label
                                  color="error"
                                  text-color="white"
                                  >Meta atingida</v-chip
                                >
                                <v-chip
                                  v-else-if="eq.metaSuperada"
                                  x-small
                                  label
                                  outlined
                                  color="success"
                                  >Meta superada</v-chip
                                >
                                <v-spacer></v-spacer>
                                <span class="text-caption text--secondary">
                                  {{ eq.cadastrados }}/{{ eq.meta }}
                                </span>
                                <v-progress-linear
                                  :value="eq.percentual"
                                  :color="corProgresso(eq)"
                                  height="5"
                                  rounded
                                  style="max-width: 80px"
                                ></v-progress-linear>
                              </div>
                            </template>
                          </v-checkbox>

                          <v-tooltip v-if="eq.disabled" bottom>
                            <template #activator="{ on, attrs }">
                              <v-icon small v-bind="attrs" v-on="on" class="ml-1"
                                >mdi-lock</v-icon
                              >
                            </template>
                            <span
                              >Esta equipe atingiu a meta e não aceita novos
                              cadastros.</span
                            >
                          </v-tooltip>
                        </div>

                        <v-messages
                          :value="candidatosErrors"
                          color="error"
                          class="px-1 mt-1"
                        ></v-messages>
                      </fieldset>
                    </v-col>
                    <v-col class="pa-0" cols="12" xs="12" v-if="parceiraAtiva">
                      <v-switch
                        v-model="editedItem.compartilhar_parceira"
                        :label="`Compartilhar com a campanha ${parceiraNome}`"
                        hint="Quando ativado, esta pessoa também será visível para a outra campanha. Pode ser alterado depois em 'Minhas Pessoas'."
                        persistent-hint
                        color="green"
                        class="mt-0"
                      ></v-switch>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Sair</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salvar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon title="Editar Usuário" class="mr-2" @click="editItem(item)"
          >mdi-pencil</v-icon
        >
        <v-icon title="Remover Usuário" @click="deleteItem(item)"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
import AclAPI from "./../../api/acl";
import ParceiraAPI from "./../../api/parceira";
import { validarCPF, validarTituloEleitoral } from "./../../helpers";
import { mapGetters } from "vuex";

export default {
  props: ["atualizarUsu"],
  name: "Acl",
  data: () => ({
    dialog: false,
    search: "",
    desserts: [],
    options: {
      sortBy: ["cad_dup"], // Definindo para ordenar pela coluna cad_dup inicialmente
      sortDesc: [true], // Definindo a direção da ordenação (false para crescente)
    },
    editedIndex: -1,
    selects: {
      perfil: {
        items: [],
      },
      candidatos: {
        items: [],
      },
      zonas: {
        value: 0,
        items: [],
      },
    },
    editedItem: {
      id: "",
      nome_completo: "",
      cpf: "",
      titulo_eleitoral: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
      observacoes: "",
      compartilhar_parceira: false,
      candidatos: [],
    },
    defaultItem: {
      id: "",
      nome_completo: "",
      cpf: "",
      titulo_eleitoral: "",
      email: "",
      telefone: "",
      zona: "",
      secao: "",
      facebook: "",
      instagram: "",
      observacoes: "",
      compartilhar_parceira: false,
      candidatos: [],
    },
    metas: {
      total: "",
      total_cad: "",
      show: true,
    },
  }),

  validations() {
    return {
      editedItem: {
      nome_completo: {
        required,
        minLength: minLength(6),
      },
      cpf: {
        cpfValido: (v) => !v || validarCPF(v),
      },
      titulo_eleitoral: {
        required,
        tituloValido: (v) => validarTituloEleitoral(v),
      },
      email: {
        email,
      },
      telefone: {
        required,
        isPhoneNumber: helpers.regex(
          "telefone",
          /^\(([0-9]{2})\) 9([0-9])(?!\2{3}-(\2{4}))([0-9]{3})-([0-9]{4})$/
        ),
      },

      zona: {
        required,
      },
      secao: {
        required,
      },
      candidatos: {
        // Obrigatorio ao menos uma equipe apenas quando o campo aparece
        // (assessor com mais de uma equipe). Assessor de equipe unica/legado e isento.
        peloMenosUma: (v) =>
          (this.listaCandidatos || []).length <= 1 ||
          (Array.isArray(v) && v.length > 0),
      },
      },
    };
  },

  computed: {
    ...mapGetters({
      listaCandidatos: "candidato_ativo/lista",
      candidatoAtivoId: "candidato_ativo/idcandidato",
    }),

    // Colunas da tabela. A coluna "Equipes" (compartilhamento) so aparece
    // para assessor que atende mais de uma equipe.
    headers() {
      const cols = [
        { text: "ID", value: "idpessoa" },
        { text: "Nome Completo", align: "left", value: "nome_completo" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Assessor", value: "assessor.name" },
        { text: "Observações", value: "observacoes", sortable: false },
        { text: "Análise de Cadastro", value: "cad_dup" },
        { text: "Ações", value: "action", sortable: false },
      ];
      if ((this.listaCandidatos || []).length > 1) {
        // Insere "Equipes" entre Assessor e Análise de Cadastro.
        cols.splice(5, 0, { text: "Equipes", value: "equipes", sortable: false });
      }
      return cols;
    },

    // Equipes com progresso (cad/meta) e bloqueio dos cheios para a lista de checkboxes.
    // Uma equipe cheia so e bloqueada se NAO estiver ja marcada nesta pessoa.
    candidatosParaSelecao() {
      const marcados = this.editedItem.candidatos || [];
      return (this.listaCandidatos || []).map((c) => {
        const meta = parseInt(c.meta, 10) || 0;
        const cad = parseInt(c.cadastrados, 10) || 0;
        const cheia = meta > 0 && cad >= meta;
        // Candidato que libera cadastro alem da meta: sinaliza, mas nao bloqueia.
        const permite = c.permite_exceder_meta == 1;
        const bloqueada = cheia && !permite;
        const jaMarcado = marcados.indexOf(c.idcandidato) !== -1;
        return {
          idcandidato: c.idcandidato,
          nome: c.nome_completo,
          meta,
          cadastrados: cad,
          metaAtingida: bloqueada,
          metaSuperada: cheia && permite,
          percentual: meta > 0 ? Math.min(100, Math.round((cad / meta) * 100)) : 0,
          disabled: bloqueada && !jaMarcado,
        };
      });
    },

    candidatosErrors() {
      const errors = [];
      if (!this.$v.editedItem.candidatos.$dirty) return errors;
      !this.$v.editedItem.candidatos.peloMenosUma &&
        errors.push("Selecione ao menos uma equipe.");
      return errors;
    },
    parceiraAtiva() {
      return localStorage.getItem("parceira_ativa") === "1";
    },
    parceiraNome() {
      return localStorage.getItem("parceira_nome") || "";
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.editedItem.nome_completo.$dirty) return errors;
      !this.$v.editedItem.nome_completo.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.nome_completo.minLength &&
        errors.push("Nome Completo  dever ser maior que 6 caracteres");
      return errors;
    },
    cpfErrors() {
      const errors = [];
      if (!this.$v.editedItem.cpf.$dirty) return errors;
      !this.$v.editedItem.cpf.cpfValido && errors.push("CPF inválido.");
      return errors;
    },
    tituloEleitoralErrors() {
      const errors = [];
      if (!this.$v.editedItem.titulo_eleitoral.$dirty) return errors;
      !this.$v.editedItem.titulo_eleitoral.required &&
        errors.push("Código principal é obrigatório.");
      !this.$v.editedItem.titulo_eleitoral.tituloValido &&
        errors.push("Código principal inválido.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email.$dirty) return errors;
      !this.$v.editedItem.email.email && errors.push("Email incorreto.");
      return errors;
    },
    telefoneErrors() {
      const errors = [];
      if (!this.$v.editedItem.telefone.$dirty) return errors;
      !this.$v.editedItem.telefone.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.telefone.isPhoneNumber &&
        errors.push("Número de Telefone fora do Padrão");
      return errors;
    },
    zonaErrors() {
      const errors = [];
      if (!this.$v.editedItem.zona.$dirty) return errors;
      !this.$v.editedItem.zona.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    secaoErrors() {
      const errors = [];
      if (!this.$v.editedItem.secao.$dirty) return errors;
      !this.$v.editedItem.secao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Pessoa" : "Editar Pessoa";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    atualizarUsu() {
      this.initialize();
    },
  },

  created() {
    this.$store.dispatch("candidato_ativo/carregarMeusCandidatos");
    this.initialize();
  },

  methods: {
    // Trunca um texto para exibicao na coluna, mantendo o valor completo no tooltip.
    truncar(texto, n) {
      if (!texto) return "";
      return texto.length > n ? texto.slice(0, n) + "…" : texto;
    },

    // Equipes vinculadas a pessoa, com a equipe ativa sempre em primeiro.
    equipesOrdenadas(item) {
      const cands = Array.isArray(item.candidatos) ? item.candidatos : [];
      return [...cands].sort((a, b) => {
        if (a.id === this.candidatoAtivoId) return -1;
        if (b.id === this.candidatoAtivoId) return 1;
        return 0;
      });
    },

    // Cor da barra de progresso da equipe por faixa de preenchimento da meta.
    corProgresso(eq) {
      if (!eq.meta) return "grey";
      if (eq.metaSuperada) return "success";
      const r = eq.cadastrados / eq.meta;
      if (r >= 1) return "error";
      if (r >= 0.8) return "amber darken-2";
      return "success";
    },

    novaPessoa() {
      this.editedItem = Object.assign({}, this.defaultItem, { candidatos: [] });
      this.editedIndex = -1;
      // Pre-seleciona o candidato ativo quando o assessor atende mais de um.
      if (this.candidatoAtivoId) {
        this.editedItem.candidatos = [this.candidatoAtivoId];
      }
      this.dialog = true;
    },

    // Busca da tabela: colunas visiveis + CPF e titulo eleitoral (que nao sao
    // colunas), comparando so os digitos para aceitar termo com ou sem mascara.
    filtroBusca(value, search, item) {
      const termo = String(search || "").toLowerCase().trim();
      if (!termo) return true;
      if (value != null && String(value).toLowerCase().includes(termo)) return true;
      const digitos = termo.replace(/\D/g, "");
      if (!digitos) return false;
      return [item.cpf, item.titulo_eleitoral].some(
        (c) => c && String(c).replace(/\D/g, "").includes(digitos)
      );
    },

    initialize() {
      const headers = this.Helpers.iniciarRequisicao();

      //Filtro Usuarios da Equipe caso tenha
      const id_assessor = localStorage.getItem("id");

      const params = {
        id_assessor: id_assessor,
      };

      // Escopa a listagem e a meta do cabecalho ao candidato ativo.
      const equipe = localStorage.getItem("equipe");
      if (equipe && equipe !== "null") {
        params.idcandidato = equipe;
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.getPessoas(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.desserts = response.data.pessoas;
              this.metas.total = parseFloat(response.data.metas.meta);
              this.metas.total_cad = parseFloat(response.data.total_cadastros);

              if (
                this.metas.total_cad < this.metas.total ||
                response.data.metas.permite_exceder_meta == 1
              ) {
                this.metas.show = true;
              } else {
                this.metas.show = false;
              }

              this.buscaZonas();
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      // Carrega os candidatos marcados (relacao pessoa_candidato eager-loaded).
      const cands = Array.isArray(item.candidatos) ? item.candidatos : [];
      this.$set(
        this.editedItem,
        "candidatos",
        cands.map((c) => c.id)
      );
      this.setZona(item.zona);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);

      const equipe = localStorage.getItem("equipe");
      const temEquipe = equipe && equipe !== "null";

      // Compartilhada = cadastro vinculado a mais de uma equipe. Nesse caso a
      // exclusao remove apenas o vinculo com a equipe ativa.
      const vinculos = Array.isArray(item.candidatos) ? item.candidatos : [];
      const compartilhada = temEquipe && vinculos.length > 1;

      const mensagem = compartilhada
        ? "Esta pessoa é compartilhada com outra equipe. Remover apenas da equipe atual? O cadastro continua disponível para as demais equipes."
        : "Deseja remover pessoa?";

      if (confirm(mensagem)) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = { idpessoa: this.editedItem.idpessoa };
        if (temEquipe) {
          params.idcandidato = equipe;
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          AclAPI.delPessoa(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.editedItem = {};
                this.initialize();
              }
            })
            .catch(() => {
              alert("Falha na operação!!!");
            })
        );
      } else {
        this.editedItem = {};
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    getReportAssessor() {
      const id_assessor = localStorage.getItem("id");
      const equipeAtiva = localStorage.getItem("equipe");
      const equipeParam =
        equipeAtiva && equipeAtiva !== "null" ? equipeAtiva : 0;

      let url =
        "relatorio_assessores?id=" +
        id_assessor +
        "&id_cd=" +
        id_assessor +
        "&equipe=" +
        equipeParam;
      window.open(process.env.VUE_APP_URL_BASE + "/api/" + url, "_blank");
    },

    save() {
      // Formulario invalido: destaca os campos com erro em vez de ignorar o clique.
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.Helpers.exibirMensagem("Preencha corretamente os campos destacados.", "error", 5000);
        return;
      }

      const headers = this.Helpers.iniciarRequisicao();

      const id_assessor = localStorage.getItem("id");

      this.editedItem.id_assessor = id_assessor;

      const compartilhar = this.parceiraAtiva && this.editedItem.compartilhar_parceira ? 1 : 0;
      const params = Object.assign({}, this.editedItem, {
        compartilhar_parceira: compartilhar,
      });

      this.$store.dispatch(
        "loading/addRequisicao",
        AclAPI.addPessoa(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              const idpessoa = response.data && response.data.idpessoa;
              if (compartilhar === 1) {
                this.replicarSeUnificado(idpessoa);
              }
              // Atualiza contagens por candidato (meta) e a listagem.
              this.$store.dispatch("candidato_ativo/carregarMeusCandidatos");
              this.initialize();
              this.close();
            }
          })
          .catch((error) => {
            const err = error.response && error.response.data && error.response.data.error;
            if (error.response && error.response.status === 422 && err === "meta_atingida") {
              const nomes = (error.response.data.candidatos || []).join(", ");
              this.Helpers.exibirMensagem(
                `Meta já atingida para: ${nomes}. Desmarque essa(s) equipe(s) para cadastrar.`,
                "error",
                7000
              );
            } else if (error.response && error.response.status === 422 && err === "cpf_duplicado") {
              this.Helpers.exibirMensagem(
                `CPF já cadastrado para ${error.response.data.nome}`,
                "error",
                6000
              );
            } else if (error.response && error.response.status === 422 && err === "titulo_duplicado") {
              const eq = error.response.data.equipe;
              this.Helpers.exibirMensagem(
                `Código principal já cadastrado para ${error.response.data.nome}` +
                  (eq ? ` na equipe ${eq}` : ""),
                "error",
                6000
              );
            } else if (error.response && error.response.status === 422 && err === "titulo_invalido") {
              this.Helpers.exibirMensagem("Código principal inválido", "error", 6000);
            } else if (error.response && error.response.status === 422 && err === "telefone_limite") {
              const nomes = (error.response.data.pessoas || []).join(" e ");
              this.Helpers.exibirMensagem(
                `Este telefone já está cadastrado para 2 pessoas${nomes ? " (" + nomes + ")" : ""}. Não é permitido um terceiro cadastro com o mesmo telefone.`,
                "error",
                7000
              );
            } else {
              alert("Falha na operação!!!");
            }
          })
      );
    },

    replicarSeUnificado(idpessoa) {
      if (!idpessoa) return;
      if (localStorage.getItem("parceira_ativa") !== "1") return;

      const headers = this.Helpers.getHeaderRequisicao();
      ParceiraAPI.replicarPessoa(headers, { idpessoa })
        .then(() => {
          this.Helpers.exibirMensagem(
            "Cadastro replicado para a base parceira.",
            "success",
            4000
          );
        })
        .catch((error) => {
          const status = error.response && error.response.status;
          const err = error.response && error.response.data && error.response.data.error;
          if (status === 422 && err === "conflito_assessor") {
            const nome = error.response.data.nome_assessor_remoto || "outro assessor";
            this.Helpers.exibirMensagem(
              `Salvo localmente. Já cadastrada na base parceira sob: ${nome}.`,
              "warning",
              8000
            );
          } else if (status === 503) {
            this.Helpers.exibirMensagem(
              "Salvo localmente. Replicação pendente — acesse 'Minhas pessoas' para retentar.",
              "warning",
              7000
            );
          } else {
            this.Helpers.exibirMensagem(
              "Salvo localmente. Falha ao replicar para a parceira.",
              "warning",
              6000
            );
          }
        });
    },

    buscaZonas() {
      const headers = this.Helpers.iniciarRequisicao();
      AclAPI.getZonas(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          this.selects.zonas.items = [];

          if (response.status == 200) {
            this.selects.zonas.items = response.data.zonas;
          }
        })
        .catch(() => {
          this.Helpers.logout();
        });
    },
    setZona(zona) {
      if (zona != "null") {
        this.editedItem.zona = parseInt(zona);
        this.selects.zonas.ativado = true;
      }
    },
  },
};
</script>
<style scoped>
.equipes-group {
  border: 1px solid rgba(0, 0, 0, 0.38);
}
.equipes-group--error {
  border-color: #ff5252;
}
.equipes-group legend {
  color: rgba(0, 0, 0, 0.6);
}
.equipes-group--error legend {
  color: #ff5252;
}
</style>